import {useEffect, useState} from 'react'
import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import tabsMenuAlumni from '../modules/profile/tabsMenuAlumni'
import tabsMenuCompany from '../modules/profile/tabsMenuCompany'
import {
  menusAdditionalAlumni,
  menusAdmin,
  menusAlumniTalenta,
  menusAlumniPana,
  menusCompany,
  menusAssessment,
  menusReviewer,
  menusAdminVT,
  menusMitraProgramPANA,
} from '../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuMain'
import JobDetail from '../modules/profile/components/Jobs/Detail'
import {useNavigate} from 'react-router-dom'
import {Button} from 'react-bootstrap'
import Contains from 'utils/helpers/Contains'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const navigate = useNavigate()

  const [finalMenu, setFinalMenu] = useState<any>([])
  const [routeMenu, setRouteMenu] = useState<any>([])
  const [role, setRole] = useState(localStorage.getItem('role') || null)
  const [alumniPage, setAlumniPage] = useState(localStorage.getItem('alumniPage') || null)

  useEffect(() => {
    setRole(localStorage.getItem('role'))
    setAlumniPage(localStorage.getItem('alumniPage'))
    menu()
  }, [])

  const menu = () => {
    const allowedUrl = [
      '/crafted/pages/profile/company-overview',
      '/crafted/pages/profile/company-job',
    ]
    const currentUri = window.location.pathname

    if (role === 'company') {
      setFinalMenu(tabsMenuCompany)
      setRouteMenu(menusCompany)
    } else if (role === 'Alumni') {
      setFinalMenu(tabsMenuAlumni)

      const routeMenu = alumniPage === 'pana' ? menusAlumniPana : menusAlumniTalenta
      setRouteMenu(routeMenu)
    } else if (role === 'Super_Admin') {
      setFinalMenu([])
      // setRouteMenu(menusAdmin) //disable this for now
      setRouteMenu(menusAdmin)
    } else if (role == 'Reviewer_Administrasi_Pana') {
      setRouteMenu(menusReviewer)
    } else if (role == 'Reviewer_Substansi_Pana' || role == 'Reviewer_Proposal_Pana') {
      setRouteMenu(menusAssessment)
    } else if (role === 'Mitra_Program_PANA') {
      setFinalMenu([])
      setRouteMenu(menusMitraProgramPANA)
    } else {
      const isAllowedUrl =
        currentUri?.includes(allowedUrl[0]) || currentUri?.includes(allowedUrl[1])

      if (isAllowedUrl) {
        setFinalMenu(menusAdditionalAlumni)
      } else {
        setFinalMenu(tabsMenuAlumni)
      }

      setRouteMenu(menusAlumniTalenta)
    }
  }

  // 🔸 Jika routeMenu belum siap, jangan render Routes dulu
  if (!routeMenu || routeMenu.length === 0) {
    return <div>Loading...</div>
  }

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect ke dashboard setelah login */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />

        {/* 🔸 Dynamic route berdasarkan role */}
        {routeMenu.map((item: any, key: any) => {
          // Render child routes jika ada
          if (item?.child?.length > 0) {
            return item.child.map((item2: any, key2: any) => (
              <Route path={item2.path} key={`${key}-${key2}`} element={item2.component} />
            ))
          }
          // Render parent route jika tidak ada child atau component ada
          if (item.component) {
            return <Route path={item.path} key={key} element={item.component} />
          }
          return null
        })}

        {/* 🔸 Tambahan route alumni */}
        {menusAdditionalAlumni?.map((item: any, key: any) => (
          <Route path={item.path} key={key} element={item.component} />
        ))}

        {/* 🔸 Route statis */}
        <Route path='/job-search/:jobId' element={<JobDetail />} />

        {/* 🔸 Route khusus profile */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              {!Contains('Alumni Company', [role]) && (
                <Button
                  onClick={() => navigate(-1)}
                  className='btn-sm mb-8'
                  style={{padding: '4px'}}
                >
                  <i className='bi bi-arrow-left fs-1'></i>
                </Button>
              )}
              <ProfilePage
                menus={
                  role === 'Super_Admin' ||
                  role === 'company' ||
                  role === 'Reviewer_Administrasi_Pana' ||
                  role === 'Reviewer_Substansi_Pana' ||
                  role === 'Reviewer_Proposal_Pana'
                    ? tabsMenuAlumni
                    : finalMenu
                }
              />
            </SuspensedView>
          }
        />

        {/* 🔸 404 fallback hanya di level ini */}
        <Route path='*' element={<Navigate to='/error/404' replace />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
